<template>
  <div class="animated fadeIn">
    <b-container fluid class="pt-3 pr-3 pb-0 pl-3">
      <b-row>
        <b-col>
          <!-- Cancellations -->
          <b-card class="border-0">
            <div class="card-text pb-0">
              <div class="d-flex flex-row justify-content-start">
                <div class="text-dark mr-3">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M18 24l-6-5.269-6 5.269v-24h12v24z"/></svg>
                </div>
                <div class="h4 font-weight-bold text-dark">Kommende aftaler</div>
              </div>
            </div>
          </b-card>
          <b-card class="border-0">
            <div class="card-text pb-0">
             <p class="h6 open-sans line-height-golden py-4">Vi har været i gang med at opdatere din partnerprofil med en ny feature: markedspladsen!
							I menuen til venstre kan du nu klikke dig ind på vores <a variant="link" href="#/markedsplads">online markedsplads</a>, hvor du kan få adgang til alle møderne, der matcher din profil,
							og købe møder udenom SMS-køen. Vær opmærksom på, at vi løbende kommer til at optimere markedspladsen.</p>

            </div>
          </b-card>
          <b-card class="pt-0 pr-2 pb-0 border-0">
            <div class="card-text">
              <newmeetings></newmeetings>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import newmeetings from './MeetingsTable'
export default {
  components: {
    newmeetings
  }
}
</script>
<style scoped>
.modal-footer,
.modal-header {
  border-bottom: 0;
  border-top: 0;
}
</style>


// WEBPACK FOOTER //
// NewMeetings.vue?73187ea8